module.exports = __webpack_public_path__ + "static/img/green_4.63de9a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/green_4.png
// module id = IxrP
// module chunks = 1